import { BaseOptionType } from "antd/lib/select";
import { WebApiMemberDtoGroupDto, WebApiModelsMembershipProduct, WebApiMemberDtoMemberDto } from "../Repository/eventbookyapi";
import { MemberStatusType } from "../Types/MemberStatusType";

export const mapGroupToListItem = (groupsDto: WebApiMemberDtoGroupDto[]) => {
    let groups: BaseOptionType[] = [];
    groupsDto.forEach((group: WebApiMemberDtoGroupDto) => {
        groups.push({ value: group.id, label: group.name })
    });

    return groups;
}

export const mapMemberStatusToListItem = (members?: WebApiMemberDtoMemberDto[]) => {
    let groups: BaseOptionType[] = [];
    groups.push({ value: MemberStatusType.Active, label: "Aktiva" })
    groups.push({ value: MemberStatusType.Cancelled, label: "Avslutade" })
    groups.push({ value: MemberStatusType.UnconfirmedEmail, label: "Obekräftad e-post" })

    // Only show UnconfirmedInitialPayment if at least one member has this status
    if (members?.some(m => m.status === MemberStatusType.UnconfirmedInitialPayment)) {
        groups.push({ value: MemberStatusType.UnconfirmedInitialPayment, label: "Obekräftad första betalning" })
    }

    return groups;
}

export const mapMemberStatusToString = (type: MemberStatusType) => {
    switch (type) {
        case MemberStatusType.Active:
            return "Aktiv";
        case MemberStatusType.Cancelled:
            return "Avslutad";
        case MemberStatusType.UnconfirmedEmail:
            return "Obekräftad e-post";
        case MemberStatusType.UnconfirmedInitialPayment:
            return "Obekräftad första betalning";
        default:
            return "Aktiv"
    }
}

export const mapToMemberStatus = (statusAsString: string) => {
    if (statusAsString === "Avslutad" || statusAsString === "Cancelled") {
        return MemberStatusType.Cancelled
    }
    else if (statusAsString === "Obekräftad e-post" || statusAsString === "Unconfirmed email") {
        return MemberStatusType.UnconfirmedEmail
    }
    else if (statusAsString === "Obekräftad första betalning" || statusAsString === "Unconfirmed Initial Payment") {
        return MemberStatusType.UnconfirmedInitialPayment
    }

    return MemberStatusType.Active;
}

export const mapGroupToListItemExcludeDefaultGroup = (groupsDto: WebApiMemberDtoGroupDto[]) => {
    let groups: BaseOptionType[] = [];
    groupsDto.forEach((group: WebApiMemberDtoGroupDto) => {
        if (group.isDefaultGroup == true) {
            return;
        }
        groups.push({ value: group.id, label: group.name })
    });

    return groups;
}

export const mapMembershipProductsToListItem = (membershipProducts: WebApiModelsMembershipProduct[]) => {
    let products: BaseOptionType[] = [];

    // Add "All" option first
    products.push({ value: -1, label: "Alla medlemskap" });

    membershipProducts.forEach((product: WebApiModelsMembershipProduct) => {
        products.push({ value: product.id, label: product.name })
    });

    return products;
}